import { z } from 'zod';
import { requireFields, yesNoUnknown } from '@utils/form-schema';
import type { ISurveyModel } from '@/types/surveys/survey';

export const createSurveySchema = (model: Pick<ISurveyModel, 'askReimbursementQuestion' | 'requireIncomeRange'>) => {
    return z
        .object({
            surveySurgeonCare: z.string(),
            surveyNurseCare: z.string(),
            surveyPainCare: z.string(),
            surveyCaretakerTreatment: z.string(),
            annualIncomeRange: z.string(),
            surveyDonationWasFinancialBurden: z.string(),
            surveyDonationCostWasImportant: z.string(),
            surveyNeededReimbursement: yesNoUnknown,
            commendations: z.string(),
            comments: z.string(),
        })
        .superRefine((data, ctx) => {
            requireFields(
                ctx,
                data,
                'surveySurgeonCare',
                'surveyNurseCare',
                'surveyPainCare',
                'surveyCaretakerTreatment',
                'surveyDonationWasFinancialBurden',
                'surveyDonationCostWasImportant',
                'commendations',
                'comments',
            );

            if (model.requireIncomeRange) {
                requireFields(ctx, data, 'annualIncomeRange');
            }

            if (model.askReimbursementQuestion) {
                requireFields(ctx, data, 'surveyNeededReimbursement');
            }
        });
};
